export default "__VITE_ASSET__D5r6GUm9__"